import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ApiError, fetchSite } from "../lib/api-client";
import { ErrorAlert } from "../components/Alert";
import { TagSnippet } from "../components/TagSnippet";
import type { Site } from "../lib/types";

export function SiteDetailPage() {
  const { siteId } = useParams<{ siteId: string }>();
  const [site, setSite] = useState<Site | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!siteId) return;
    setIsLoading(true);
    fetchSite(siteId)
      .then(setSite)
      .catch((err) => setError(err instanceof ApiError ? err.message : "サイト情報の取得に失敗しました"))
      .finally(() => setIsLoading(false));
  }, [siteId]);

  if (isLoading) {
    return <p className="text-sm text-gray-500">読み込み中...</p>;
  }

  if (!site) {
    return <ErrorAlert message={error ?? "サイトが見つかりません"} />;
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-semibold">{site.name}</h1>
        <p className="text-sm text-gray-500">{site.domain}</p>
        <p className="text-xs text-gray-400 mt-1">
          SITE_KEY: <code>{site.siteKey}</code>
        </p>
      </div>

      <ErrorAlert message={error} />

      <TagSnippet siteKey={site.siteKey} />

      <div className="grid gap-4 sm:grid-cols-2">
        <Link
          to={`/sites/${site.id}/pages`}
          className="block bg-white border border-gray-200 rounded-lg p-4 hover:border-blue-400"
        >
          <h2 className="text-base font-semibold">ページ管理</h2>
          <p className="text-sm text-gray-500 mt-1">計測対象のページ（URLパターン）を登録・管理します</p>
        </Link>
        <Link
          to={`/sites/${site.id}/goals`}
          className="block bg-white border border-gray-200 rounded-lg p-4 hover:border-blue-400"
        >
          <h2 className="text-base font-semibold">ゴール管理</h2>
          <p className="text-sm text-gray-500 mt-1">
            CVポイント（GA4イベント連携・セレクタ・URL到達等）を登録・管理します
          </p>
        </Link>
      </div>
    </div>
  );
}
